import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { PhosphorIcon } from 'district-ui-client/components/phosphor-icon'
import type { SafeString } from '@ember/template'
import { InlineAlert, AlertType } from 'district-ui-client/components/inline-alert'

export interface StudentImportError {
  csvRow?: number
  detail: string | SafeString
}

interface Signature {
  Args: {
    messages: StudentImportError[]
  }
}
export const ImportPanelStudentErrors: TOC<Signature> = <template>
  <div data-test-upload-errors>
    <InlineAlert @type={{AlertType.Critical}} class="mt-5">
      {{t "manage.studentCsv.errorInlineFlash" htmlSafe=true}}
    </InlineAlert>

    <table class="mt-5 w-full bg-white">
      <thead>
        <tr class="border-l border-r border-dusty-black-250">
          <th class="w-24 border-r border-white bg-dusty-black-250 p-5 font-normal text-white"></th>
          <th class="w-64 border-r border-white bg-dusty-black-250 p-5 text-center font-normal text-white">{{t
              "manage.csv.lineNo"
            }}</th>
          <th class="border-0 border-r border-white bg-dusty-black-250 p-5 font-normal text-white">{{t
              "manage.csv.rowErrorHeading"
            }}</th>
        </tr>
      </thead>
      <tbody class="border-l border-r border-dusty-black-100">
        {{#each @messages as |error index|}}
          <tr data-test-error-row={{index}}>
            <td
              class="flex items-center justify-center border-b border-dusty-black-100 bg-watermelony-red-50 p-5 text-center"
            >
              <PhosphorIcon @icon="phosphor-warning-fill" class="text-watermelony-red-300" />
            </td>
            <td
              class="border-b border-dusty-black-100 bg-watermelony-red-50 p-5 text-center font-normal"
              data-test-error-csv-line-cell
            >
              {{#if error.csvRow}}
                {{error.csvRow}}
              {{else}}
                {{t "manage.csv.na"}}
              {{/if}}
            </td>
            <td class="border-b border-dusty-black-100 bg-watermelony-red-50 p-5 font-normal" data-test-error-msg-cell>
              {{error.detail}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </div>
</template>

export default ImportPanelStudentErrors
